import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { AppConfigService } from './app.config'
import { storeObj, getObj } from '../global';

@Injectable()
export class AzureClient {
    private _client: any

    _azureLogin$: Subject<any> = <Subject<any>>new Subject();
    get azureLogin$() { return this._azureLogin$.asObservable(); }

    _error$: Subject<any> = <Subject<any>>new Subject();
    get error$() { return this._error$.asObservable(); }

    constructor(private appConfig: AppConfigService) {
        // Create a reference to the Azure App Service
        var WindowsAzure = require('azure-mobile-apps-client');
        this._client = new WindowsAzure.MobileServiceClient(appConfig.apiURL).withFilter(AzureClient.filter); // dev value
    }

    public login() {
        this._client.login('aad', { 'access_token': localStorage.getItem('adal.idtoken') })
            .then((data: any) => {
                storeObj('azure-user', data);
                this._azureLogin$.next(data);
            },
                (error) => {
                    console.error(error);
                    this._error$.next(error);
                });
    }

    public get client() {
        this._client.currentUser = getObj('azure-user');
        return this._client;
    }

    static filter(request, next, callback) {
        // Added these to request headers attempting to avoid the 
        // Refused to get unsafe header "Link"
        // message.  It's not working, at least on Chrome.
        request.headers['Access-Control-Expose-Headers'] = "ETag, Link";

        next(request, callback);
    }
}